import React, { useContext } from "react";
import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import FreeTicket from "views/Components/ServicesOperationComponent/PanelAdmin/FreeTicket";
import EditConst from "views/Components/ServicesOperationComponent/PanelAdmin/EditConst";
import { AppGlobalContext } from "contexts/GlobalContext";
import { useBoundStore } from "useStore";

function CustomTabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`panel-tabpanel-${index}`}
      aria-labelledby={`panel-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `panel-tab-${index}`,
    "aria-controls": `panel-tabpanel-${index}`,
  };
}

const ServiceOperationPanelAdmin = () => {
  const { mainCountry } = useContext(AppGlobalContext);
  const activeTab = useBoundStore((state) => state.soPanelActiveTab);
  const setActiveTab = useBoundStore((state) => state.setSoPanelActiveTab);

  return (
    <div style={{ height: "100%" }}>
      <Stack spacing={1}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            fontSize: "32px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          Panel de configuración
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            fontSize: "14px",
            color: "#000000DE",
            lineHeight: "24px",
          }}
        >
          Adminel · Tablas de opciones y liberación de tickets
        </Typography>
      </Stack>

      <Box sx={{ mt: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          aria-label="panel admin tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            borderRadius: "6px",
            width: "fit-content",
            border: "1px solid #0000001F",
            overflow: "hidden",
            minHeight: "48px",
            height: "48px",
            "& .MuiTabs-flexContainer": { height: "100%" },
          }}
        >
          <Tab
            label="Liberar Ticket"
            {...a11yProps(0)}
            sx={{
              height: "100%",
              color: "#000000DE",
              borderRight: "1px solid #0000001F",
              "&.Mui-selected": { backgroundColor: "#002878", color: "#FFFFFF" },
              "&:hover": { backgroundColor: "#002878", color: "#FFFFFF" },
            }}
          />
          <Tab
            label="Editar Constantes"
            {...a11yProps(1)}
            sx={{
              height: "100%",
              color: "#000000DE",
              "&.Mui-selected": { backgroundColor: "#002878", color: "#FFFFFF" },
              "&:hover": { backgroundColor: "#002878", color: "#FFFFFF" },
            }}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={activeTab} index={0}>
        <FreeTicket mainCountry={mainCountry} />
      </CustomTabPanel>
      <CustomTabPanel value={activeTab} index={1}>
        <EditConst mainCountry={mainCountry.id} />
      </CustomTabPanel>
    </div>
  );
};

export default ServiceOperationPanelAdmin;